export default "__VITE_ASSET__9X_nEtiv__"